import(/* webpackMode: "eager" */ "/codebuild/output/src1267868240/src/pixelated-tech/apps/simple-day-concierge/src/app/loading.tsx");
